/* eslint-disable @typescript-eslint/no-unused-vars */
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import CountdownV2 from "components/CountdownV2";
import {
	Container,
	DataContainer,
	ItemImage,
	RewardContainer,
	Circle,
	RewardItem,
	Subtitle,
	EarnBox,
	EarnedNumber,
	EarnedText,
	InboxMessage,
	ButtonsContainer,
	CustomButton,
	Background,
	CountdownStyles,
	CountdownIconStyles,
	CountdownLabelStyles,
	CountdownStylesPortrait
} from "./styles";
import { rebateOfferAssets } from "assets/cdn";
import BackToGameButton from "components/Buttons/BackToGameButton";
import { isMobile } from "react-device-detect";
import { ProgressBar } from "../ProgressBar";
import { highlight } from "../helpers";
import { useRebateMainPopupLogic } from "./hooks/useRebateMainPopupLogic";
import { useImagePath } from "hooks/useImagePath";

interface Props {
	id: string;
}

export const RebateMainPopup = ({ id }: Props) => {
	const { getImage } = useImagePath("cdn");
	const {
		scale,
		rewardType,
		currentProgress,
		rebateOfferData,
		onClose,
		sendAnalytics,
		isPortrait,
		nowTime,
		handleOnEnd
	} = useRebateMainPopupLogic();
	const backgroundImage = getImage(
		isPortrait
			? rebateOfferAssets.backgroundPortrait
			: rebateOfferAssets.backgroundLandscape
	);
	const earnBoxImage = getImage(rebateOfferAssets.earnBox);

	return (
		<Container scale={scale}>
			<Background imageUrl={backgroundImage}></Background>
			{rebateOfferData?.rebateTracker?.expirationDate && (
				<CountdownV2
					text="Event ends in: "
					startTime={nowTime}
					endTime={rebateOfferData?.rebateTracker?.expirationDate ?? ""}
					onEnd={handleOnEnd}
					style={isPortrait ? CountdownStylesPortrait : CountdownStyles}
					iconStyle={CountdownIconStyles}
					labelStyle={CountdownLabelStyles}
				/>
			)}
			<CloseIconButton onClose={onClose} />
			<Subtitle>
				Earn {highlight(rebateOfferData?.rebateTracker?.rebateReturn + " ")}
				{highlight(
					(rebateOfferData?.rebateTracker?.rebateReturn ?? 0) > 1
						? rewardType?.pluralLabel
						: rewardType?.singularLabel
				)}{" "}
				back for every{" "}
				{highlight(rebateOfferData?.rebateTracker?.targetSpend + " used")}!
			</Subtitle>
			<DataContainer>
				<EarnBox $backgroundImage={earnBoxImage}>
					<Circle>
						<RewardContainer>
							<RewardItem>
								<ItemImage src={rewardType?.imageUrl} alt="" />
							</RewardItem>
						</RewardContainer>
						<ProgressBar
							currentProgress={currentProgress}
							totalProgress={rebateOfferData?.rebateTracker?.targetSpend ?? 0}
							isCurrentTierActive={true}
						/>
					</Circle>
					<EarnedText>{"Earned:"}</EarnedText>
					<EarnedNumber>
						{rebateOfferData?.rebateTracker?.earnedCount}
					</EarnedNumber>
				</EarnBox>
			</DataContainer>
			<ButtonsContainer>
				<CustomButton
					variant="contained"
					onClick={() => {
						sendAnalytics("event_screen_enter");
						onClose();
					}}
				>
					{"Continue Shopping"}
				</CustomButton>
				{isMobile && (
					<BackToGameButton
						styles={{
							width: isPortrait ? "100%" : "60%",
							marginTop: "0.5em",
							height: "2.8em",
							fontSize: "1em"
						}}
						themeColor="secondary"
						source="rebate-offer"
					/>
				)}
			</ButtonsContainer>
			<InboxMessage>
				{"Items will be sent to the Inbox at end of event"}
			</InboxMessage>
		</Container>
	);
};
